import { Box, Typography, Skeleton } from '@mui/material';
import { useFueCompleted, useL10n } from '@uplift/hooks';
import { useMemo } from 'react';
import { BookNewClients } from './components/book-new-clients.component';
import { NextSession } from './components/next-session.component';
import { SessionsList } from './components/today-sessions-list.component';
import { Welcome } from './components/welcome.component';
import { useTodaysAppointments } from './hooks/use-todays-appointments.hook';

export const TodaysSessions: React.FC = () => {
  const l10n = useL10n();
  const { fueCompleted, isFetching: isFetchingFueCompleted } = useFueCompleted();
  const { todaysAppointments, nextAppointment, fetching: isFetchingTodaysAppointments, refetchOnUpdate } = useTodaysAppointments();

  const loading = useMemo(() => (isFetchingFueCompleted || isFetchingTodaysAppointments), [ isFetchingFueCompleted, isFetchingTodaysAppointments ]);

  const content = useMemo(() => {
    if (loading) {
      return <Skeleton width="100%" height="268px" variant="rectangular" />;
    }
    if (todaysAppointments) {
      return <SessionsList refreshOnUpdate={refetchOnUpdate} sessions={todaysAppointments} />;
    }
    if (nextAppointment) {
      return <NextSession nextSession={nextAppointment} />;
    }

    // EMPTY STATES
    if (fueCompleted === false) {
      return <Welcome />;
    }

    return <BookNewClients />;
  }, [ loading, fueCompleted, nextAppointment, refetchOnUpdate, todaysAppointments ]);

  return (
    <div>
      <Box mb={3} ml={{ xs: 2, md: 0 }}>
        <Typography variant="h3">
          {l10n.sessions.todaysSessions}
        </Typography>
      </Box>
      {content}
    </div>
  );
};
